import { Component, OnChanges, SimpleChanges, Input } from '@angular/core';
import { getRandomColorWithOpacity } from '@piqet-angular/data';
import { FixedDecimal } from '@piqet-angular/shared';
import * as Highcharts from 'highcharts';

@Component({
  selector: 'piqet-angular-radar-chart',
  templateUrl: './radar-chart.component.html',
  styleUrls: ['./radar-chart.component.scss'],
})
export class RadarChartComponent implements OnChanges {
  Highcharts: typeof Highcharts = Highcharts;
  chartOptions: Highcharts.Options = {};
  @Input() spiderChartData: any = [];
  @Input() chartOpacity!: number;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['spiderChartData']) {
      this.spiderChartData = changes['spiderChartData'].currentValue;
      this.chartOpacity = changes['chartOpacity']?.currentValue?.value;
      this.spiderChartData && this.generateChart();
    }
  }
  ngOnInit() {
    // this.generateChart();
  }

  generateChart() {
    const indicators = this.spiderChartData[0].indicators?.split(';');
    const imageUrls = this.spiderChartData[0].indicatorImageName?.split(';');
    const colors = getRandomColorWithOpacity(this.chartOpacity);
    const series: any = this.spiderChartData.map((item: any, index: number) => {
      return {
        name: item.name || item.scenarioname,
        data: item.totals?.split(';')?.map(Number),
        pointPlacement: 'on',
        color: colors[index].rgb,
        fillColor: colors[index].rgba,
        fillOpacity: this.chartOpacity,
      };
    });

    const formattedCategories =
      indicators.length <= 15
        ? indicators.map((indicator: any, index: any) => {
            const words = indicator?.split(' ');
            const wrappedText = words.join('<br>');
            return `<div style="text-align: center;">
        <img src="${imageUrls[index]}" style="width: 30px; height: 30px;"><br>
        <span style="white-space: normal; display: inline-block;">${indicator}</span>
      </div>`;
          })
        : indicators.map((indicator: any) => {
            const words = indicator?.split(' ');
            return words.join('\n');
          });

    this.chartOptions = {
      chart: {
        polar: true,
        type: 'area',
        marginTop: 100,
        marginBottom: 110,
      },
      title: {
        text: '',
      },
      pane: {
        size: '100%',
      },
      xAxis: {
        categories: formattedCategories,
        tickmarkPlacement: 'on',
        lineWidth: 0,
        labels: {
          distance: 45,
          useHTML: indicators.length <= 15,
        },
      },
      yAxis: {
        gridLineInterpolation: 'polygon',
        lineWidth: 0,
        min: 0,
        max: 1,
      },
      tooltip: {
        outside: true,
        useHTML: true,
        shared: false,
        backgroundColor: '#ffffff',
        borderColor: '#cccccc',
        borderRadius: 8,
        borderWidth: 1,
        padding: 12,
        style: {
          fontSize: '13px',
          fontFamily: 'Neue Montreal, sans-serif',
        },
        formatter: function () {
          const value: any = this.y;
          if (value === null) return false;
          const pointIndex = this.index;
          const indicators = this.series.chart.xAxis[0].categories;
          const seriesName = this.series?.name;

          // Get the clean indicator text without HTML
          const categoryText = indicators[pointIndex];

          let displayValue = value;
          if (Math.abs(value) < 0.001) {
            displayValue = value.toExponential(2);
          } else {
            displayValue = value.toFixed(FixedDecimal);
          }

          return `
            <div style="min-width: 150px; max-width: 250px; padding: 4px;">
              <div style="font-weight: bold; margin-bottom: 6px; color: #333;">
                ${categoryText}
              </div>
              <div style="display: flex; align-items: center; gap: 8px;">
                <span style="background-color: ${this.color}; width: 10px; height: 10px; border-radius: 50%; display: inline-block;"></span>
                <span style="color: #666;">${seriesName}: <b style="color: #333;">${displayValue}</b></span>
              </div>
            </div>
          `;
        },
      },
      credits: {
        enabled: false,
      },
      plotOptions: {
        area: {
          marker: {
            enabled: false,
          },
          fillOpacity: this.chartOpacity,
        },
        series: {
          states: {
            inactive: {
              enabled: false,
            },
          },
        },
      },

      legend: {
        align: 'center',
        verticalAlign: 'bottom',
        layout: 'horizontal',
        y: 20,
        itemStyle: {
          fontSize: '14px',
          fontFamily: 'Neue Montreal !important',
        },
        labelFormatter: function () {
          return `<span style="display: flex; align-items: center; margin-top: 15px;">
            <span style="background-color: ${this.color}; width: 10px; height: 10px; border-radius: 50%; display: inline-block; margin-right: 8px;"></span>
                <span style="font-size: 14px;font-family: 'Neue Montreal', sans-serif;">${this.name}</span>
          </span>`;
        },
        useHTML: true,
        symbolHeight: 0,
        symbolWidth: 0,
        symbolRadius: 0,
      },
      series: series,
    };
  }
}
